// ハンバーガーメニュー(utils)
window.initHamburgerMenu = (options = {}) => {
  const {
    btnSelector = '.js-gNav__btn',
    targetSelector = '.js-gNav__target',
    activeClass = 'is-active',
    fixedClass = 'is-fixed',
    breakpoint = 991,
    idPrefix = 'gnav',
  } = options;

  const btns = document.querySelectorAll(btnSelector); // すべてのボタンを取得
  const nav = document.querySelector(targetSelector);
  if (btns.length === 0 || !nav) return;

  const mql = window.matchMedia(`(max-width: ${breakpoint}px)`);

  /**
   * 状態同期：クラス、aria属性、body固定を一括管理
   */
  const syncState = (isOpen) => {
    btns.forEach(btn => {
      btn.classList.toggle(activeClass, isOpen);
      btn.setAttribute('aria-expanded', isOpen);
    });
    
    nav.classList.toggle(activeClass, isOpen);
    nav.setAttribute('aria-hidden', !isOpen);

    if (isOpen) {
      document.body.classList.add(fixedClass);
    } else {
      document.body.classList.remove(fixedClass);
    }
  };

  /**
   * 初期化およびブレイクポイント跨ぎの処理
   */
  const updateAttributes = (isMobile) => {
    if (isMobile) {
      // IDの付与とaria-controlsの紐付け（未設定の場合のみ）
      if (!nav.id) nav.id = idPrefix;
      btns.forEach(btn => {
        if (!btn.getAttribute('aria-controls')) {
          btn.setAttribute('aria-controls', nav.id);
        }
      });

      // 現在のnavのクラス状態を「正」として初期同期
      const initialState = nav.classList.contains(activeClass);
      syncState(initialState);
    } else {
      // PC時は属性を削除し、状態をクリーンにする
      btns.forEach(btn => {
        btn.removeAttribute('aria-expanded');
        btn.removeAttribute('aria-controls');
        btn.classList.remove(activeClass);
      });
      nav.removeAttribute('aria-hidden');
      nav.classList.remove(activeClass);
      document.body.classList.remove(fixedClass);
    }
  };

  const toggle = () => {
    if (!mql.matches) return;
    const nextState = !nav.classList.contains(activeClass);
    syncState(nextState);
  };

  // 実行
  updateAttributes(mql.matches);
  mql.addEventListener('change', (e) => updateAttributes(e.matches));
  btns.forEach(btn => btn.addEventListener('click', toggle));
};

// アコーディオン＆ドロップダウン(utils)
window.initCollapse = (options = {}) => {
  const {
    parentSelector = '.js-collapse',
    btnSelector = '.js-collapse__btn',
    hoverSelector = '.js-collapse__hover',
    targetSelector = '.js-collapse__target',
    activeClass = 'is-active',
    mediaType = 'max',
    breakpoint = 9999,
    isFade = false,
    idPrefix = 'collapse'
  } = options;

  const parents = document.querySelectorAll(parentSelector);
  const mql = window.matchMedia(`(${mediaType}-width: ${breakpoint}px)`);

  let isHoveredTrigger = false;

  /**
   * 状態同期：クラス、aria属性、高さを一括管理
   */
  const syncState = (parent, btn, target, isOpen) => {
    btn.setAttribute('aria-expanded', isOpen);
    target.setAttribute('aria-hidden', !isOpen);
    parent.classList.toggle(activeClass, isOpen);

    if (!isFade) {
      target.style.maxHeight = isOpen ? `${target.scrollHeight}px` : '0px';
    }
  };

  const handleToggle = (parent, btn, target) => {
    if (!mql.matches) return;
    if (isHoveredTrigger) {
      isHoveredTrigger = false;
      return;
    }
    const isOpen = !parent.classList.contains(activeClass);
    syncState(parent, btn, target, isOpen);
  };

  const handleHoverOpen = (parent, btn, target) => {
    if (!mql.matches) return;
    if (!parent.classList.contains(activeClass)) {
      isHoveredTrigger = true;
      syncState(parent, btn, target, true);
    }
  };

  const handleHoverClose = (parent, btn, target) => {
    if (!mql.matches) return;
    isHoveredTrigger = false;
    syncState(parent, btn, target, false);
  };

  /**
   * 初期化およびブレイクポイント跨ぎ
   */
  const updateAttributes = () => {
    const isEnabled = mql.matches;
    parents.forEach((parent, parentIdx) => {
      const btn = parent.querySelector(btnSelector);
      const target = parent.querySelector(targetSelector);
      if (!btn || !target) return;

      if (isEnabled) {
        // ID紐付け
        let targetId = btn.getAttribute('aria-controls');
        if (!targetId) {
          targetId = `${idPrefix}-${parentIdx}`;
          btn.setAttribute('aria-controls', targetId);
        }
        if (!target.id) target.id = targetId;

        // 【重要】親のクラス状態を「正」として初期同期
        const initialState = parent.classList.contains(activeClass);
        syncState(parent, btn, target, initialState);
      } else {
        // 解除
        btn.removeAttribute('aria-expanded');
        btn.removeAttribute('aria-controls');
        target.removeAttribute('aria-hidden');
        parent.classList.remove(activeClass);
        if (!isFade) target.style.maxHeight = '';
      }
    });
  };

  parents.forEach((parent) => {
    const btn = parent.querySelector(btnSelector);
    const target = parent.querySelector(targetSelector);
    const hoverEl = parent.matches(hoverSelector) ? parent : parent.querySelector(hoverSelector);
    if (!btn || !target) return;

    btn.addEventListener('click', () => handleToggle(parent, btn, target));

    if (hoverEl) {
      hoverEl.addEventListener('mouseenter', () => handleHoverOpen(parent, btn, target));
      hoverEl.addEventListener('mouseleave', () => handleHoverClose(parent, btn, target));
    }

    parent.addEventListener('focusin', () => handleHoverOpen(parent, btn, target));
    parent.addEventListener('focusout', (e) => {
      // 1. 次にフォーカスが当たる要素がない（ブラウザ外や開発者ツールなど）場合は何もしない
      if (!e.relatedTarget) return;

      // 2. メニューの外（親要素の外）にフォーカスが移った時だけ閉じる
      if (!parent.contains(e.relatedTarget)) {
        handleHoverClose(parent, btn, target);
      }
    });

  });

  updateAttributes();
  mql.addEventListener('change', updateAttributes);
};

// タブメニュー(utils)
window.initTabs = (options = {}) => {
  const {
    parentSelector = '.js-tab',
    btnSelector = '.js-tab__btn',
    targetSelector = '.js-tab__target',
    activeClass = 'is-active',
    idPrefix = 'tab',
    dataKey = 'tab', // data-tab を使う
  } = options;

  const parents = document.querySelectorAll(parentSelector);

  parents.forEach((parent, parentIdx) => {
    const btns = Array.from(parent.querySelectorAll(btnSelector));
    const targets = Array.from(parent.querySelectorAll(targetSelector));
    if (btns.length === 0) return;

    // data-tab値でターゲットをマップ化
    const targetMap = new Map();
    targets.forEach((target) => {
      const key = target.dataset[dataKey];
      if (key) targetMap.set(key, target);
    });

    // ボタン⇔ターゲットのペアを作成
    // data-tabがあればそれで紐付け、なければ従来通りindexにフォールバック
    const pairs = btns.map((btn, btnIdx) => {
      const key = btn.dataset[dataKey];
      const target = (key && targetMap.get(key)) || targets[btnIdx] || null;
      return { btn, target };
    });

    // --- 初期アクティブ要素の決定ロジック ---
    let activeIdx = -1;

    pairs.forEach(({ target }, idx) => {
      if (activeIdx === -1 && target?.classList.contains(activeClass)) activeIdx = idx;
    });

    if (activeIdx === -1) {
      pairs.forEach(({ btn }, idx) => {
        if (activeIdx === -1 && btn.classList.contains(activeClass)) activeIdx = idx;
      });
    }

    if (activeIdx === -1) activeIdx = 0;

    // --- 初期化とID紐付け ---
    pairs.forEach(({ btn, target: targetPanel }, idx) => {
      if (!targetPanel) return;

      let targetId = btn.getAttribute('aria-controls');
      if (!targetId) {
        targetId = `${idPrefix}-panel-${parentIdx}-${idx}`;
        btn.setAttribute('aria-controls', targetId);
      }
      if (!targetPanel.id) targetPanel.id = targetId;

      const isActive = idx === activeIdx;

      btn.classList.toggle(activeClass, isActive);
      btn.setAttribute('aria-expanded', isActive);

      targetPanel.classList.toggle(activeClass, isActive);
      targetPanel.setAttribute('aria-hidden', !isActive);

      // --- クリックイベント ---
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        if (btn.classList.contains(activeClass)) return;

        pairs.forEach(({ btn: b, target: t }) => {
          b.classList.remove(activeClass);
          b.setAttribute('aria-expanded', 'false');
          if (t) {
            t.classList.remove(activeClass);
            t.setAttribute('aria-hidden', 'true');
          }
        });

        btn.classList.add(activeClass);
        btn.setAttribute('aria-expanded', 'true');
        targetPanel.classList.add(activeClass);
        targetPanel.setAttribute('aria-hidden', 'false');
      });
    });
  });
};

// モーダル(utils)
window.initModal = (options = {}) => {
  const {
    parentSelector = '.js-modal',
    btnSelector = '.js-modal__btn',
    closeSelector = '.js-modal__close, .js-modal__bg',
    targetSelector = '.js-modal__target',
    activeClass = 'is-active',
    fixedClass = 'is-fixed',
  } = options;

  const parent = document.querySelector(parentSelector);
  if (!parent) return;

  // 開く
  document.querySelectorAll(btnSelector).forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const id = btn.dataset.modal;
      const target = parent.querySelector(`${targetSelector}[data-modal="${id}"]`);
      if (!target) return;

      // 既存のアクティブをリセット
      parent.querySelectorAll(`${targetSelector}.${activeClass}`).forEach(el => {
        el.classList.remove(activeClass);
        el.setAttribute('aria-hidden', 'true');
      });

      // 開く
      parent.classList.add(activeClass);
      target.classList.add(activeClass);
      target.setAttribute('aria-hidden', 'false');
      document.body.classList.add(fixedClass);

      // aria
      document.querySelectorAll(`${btnSelector}[data-modal="${id}"]`).forEach(b => {
        b.setAttribute('aria-expanded', 'true');
      });
    });
  });

  // 閉じる
  parent.querySelectorAll(closeSelector).forEach(el => {
    el.addEventListener('click', () => closeAll());
  });

  function closeAll() {
    parent.querySelectorAll(`${targetSelector}.${activeClass}`).forEach(el => {
      el.classList.remove(activeClass);
      el.setAttribute('aria-hidden', 'true');
    });
    parent.classList.remove(activeClass);
    document.body.classList.remove(fixedClass);

    document.querySelectorAll(btnSelector).forEach(b => {
      b.setAttribute('aria-expanded', 'false');
    });
  }
};

// ツールチップ(utils)
window.initTooltip = (options = {}) => {
  const {
    parentSelector = '.js-tooltip',
    targetSelector = '.js-tooltip__target',
    attrName = 'data-tooltip',
    activeClass = 'is-active',
    idPrefix = 'tip'
  } = options;

  const elements = document.querySelectorAll(parentSelector);

  elements.forEach((el, idx) => {
    // 1. ターゲット（吹き出し）がない場合は生成
    let target = el.querySelector(targetSelector);
    const tooltipText = el.getAttribute(attrName);

    if (!target && tooltipText) {
      target = document.createElement('span');
      target.className = `c-tooltip ${targetSelector.replace('.', '')}`;
      target.textContent = tooltipText;
      el.appendChild(target);
    }

    if (!target) return;

    // 2. IDの自動付与と紐付け (アクセシビリティ)
    const targetId = target.id || `${idPrefix}-${idx}`;
    if (!target.id) target.id = targetId;
    el.setAttribute('aria-describedby', targetId);

    // 3. 表示・非表示イベント
    const show = () => {
      target.classList.add(activeClass);
      el.setAttribute('aria-expanded', 'true');
      target.setAttribute('aria-hidden', 'false');
    }
    const hide = () => {
      target.classList.remove(activeClass);
      el.setAttribute('aria-expanded', 'false');
      target.setAttribute('aria-hidden', 'true');
    }

    el.addEventListener('mouseenter', show);
    el.addEventListener('mouseleave', hide);
    el.addEventListener('focus', show);
    el.addEventListener('blur', hide);
  });
};

// 画像遅延読み込み(utils)
window.initLazyLoad = (options = {}) => {
  const {
    targetSelector = '.js-lazy',
    rootMargin = '0px 0px 200px 0px', // 200px手前で読み込み開始
    activeClass = 'is-loaded',       // 読み込み完了時に付与するクラス
  } = options;

  const elements = document.querySelectorAll(targetSelector);

  // IntersectionObserver 未対応ブラウザへのフォールバック
  if (!('IntersectionObserver' in window)) {
    elements.forEach((el) => {
      if (el.dataset.src) el.src = el.dataset.src;
      if (el.dataset.srcset) el.srcset = el.dataset.srcset;
    });
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const el = entry.target;

        // 1. データ属性を本来の属性に置換
        if (el.dataset.src) {
          el.src = el.dataset.src;
        }
        if (el.dataset.srcset) {
          el.srcset = el.dataset.srcset;
        }

        // 2. 読み込み完了時の処理
        // すでにキャッシュなどで読み込みが終わっている可能性も考慮
        if (el.complete) {
          el.classList.add(activeClass);
        } else {
          el.addEventListener('load', () => {
            el.classList.add(activeClass);
          }, { once: true });
        }

        // 3. 一度処理したら監視を解除
        observer.unobserve(el);
      }
    });
  }, { rootMargin });

  elements.forEach((el) => observer.observe(el));
};

// スムーススクロール(utils)
window.initSmoothScroll = (options = {}) => {
  const {
    offset = 0,
    speed = 500, // ミリ秒単位で指定可能
  } = options;

  // "#hoge" だけでなく "./#hoge" や "page.html#hoge" も拾う
  const links = document.querySelectorAll('a[href*="#"]');

  links.forEach(link => {
    link.addEventListener('click', (e) => {
      const url = new URL(link.href, window.location.href);
      const hash = url.hash;

      if (!hash || hash === "#") return;

      // 別ページへのリンクなら何もしない(通常遷移に任せる)
      // 例: /other-page.html#hoge → 現在ページと path が違う場合は除外
      if (url.pathname !== window.location.pathname) return;

      const target = document.querySelector(hash);
      if (!target) return;

      e.preventDefault();

      // 移動先の位置と現在の位置を取得
      const startPosition = window.pageYOffset;
      const targetPosition = target.getBoundingClientRect().top + startPosition - offset;
      const distance = targetPosition - startPosition;
      let startTime = null;

      // アニメーション関数
      const animation = (currentTime) => {
        if (startTime === null) startTime = currentTime;
        const timeElapsed = currentTime - startTime;

        // イージング関数（easeInOutQuad: 最初と最後が少しゆっくりになる）
        const run = ease(timeElapsed, startPosition, distance, speed);

        window.scrollTo(0, run);

        if (timeElapsed < speed) {
          requestAnimationFrame(animation);
        } else {
          // 最後に正確な位置へ調整
          window.scrollTo(0, targetPosition);
        }
      };

      // イージング計算用（お好みで変更可能）
      const ease = (t, b, c, d) => {
        t /= d / 2;
        if (t < 1) return c / 2 * t * t + b;
        t--;
        return -c / 2 * (t * (t - 2) - 1) + b;
      };

      requestAnimationFrame(animation);
    });
  });
};

// スクロールトリガー(utils)
window.initScrollTrigger = (options = {}) => {
  const {
    targetSelector = '.js-scroll',
    activeClass = 'is-show',
    overClass = 'is-over', // 上に抜けた時のクラス
    positionTop = -0.2,     // 上側は大きく取っておく（例: 100%）
    positionBottom = -0.2, // 下側（発火ライン）
    once = true,
  } = options;

  const items = document.querySelectorAll(targetSelector);

  // rootMarginの組み立て
  const marginOffsetTop = typeof positionTop === 'number' ? `${positionTop * 100}%` : positionTop;
  const marginOffsetBottom = typeof positionBottom === 'number' ? `${positionBottom * 100}%` : positionBottom;
  const rootMargin = `${marginOffsetTop} 0px ${marginOffsetBottom} 0px`;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      // 判定エリアに入っているか
      if (entry.isIntersecting) {
        entry.target.classList.add(activeClass);
        entry.target.classList.remove(overClass); // エリア内ならoverは消す
        
        if (once) observer.unobserve(entry.target);
      } else {
        // エリア外に出た時
        if (!once) {
          entry.target.classList.remove(activeClass);
        }

        // 上に抜けたかどうかの判定
        // 要素のTopが判定エリアのTopより数値として小さい（＝上にある）場合
        if (entry.boundingClientRect.top < entry.rootBounds.top) {
          entry.target.classList.add(overClass);
        } else {
          entry.target.classList.remove(overClass);
        }
      }
    });
  }, {
    rootMargin: rootMargin,
    threshold: 0
  });

  items.forEach(item => observer.observe(item));
};

// スクロールジャッジ(utils)
window.initScrollJudgement = (options = {}) => {
  const {
    scrollPosition = 100,
    targetSelector = '.js-header',
    activeClass = 'is-scrolled',
    upClass = 'is-up',
    downClass = 'is-down',
    scrollingUpClass = 'is-scrolling-up',
    scrollingDownClass = 'is-scrolling-down',
    scrollingDelayTime = 800,
  } = options;

  const target = document.querySelector(targetSelector);
  if (!target) return;

  let lastScroll = 0;
  let scrollTimeout = null;

  window.addEventListener('scroll', () => {
    const currentScroll = window.pageYOffset;

    // 1. 基本のスクロール量判定
    if (currentScroll > scrollPosition) {
      target.classList.add(activeClass);
    } else {
      target.classList.remove(activeClass);
    }

    // 2. 方向判定（確定クラスの切り替え）
    if (currentScroll > lastScroll && currentScroll > 0) {
      // 下向き
      target.classList.add(downClass);
      target.classList.remove(upClass);
      // 下向き中クラス
      target.classList.add(scrollingDownClass);
      target.classList.remove(scrollingUpClass);
    } else if (currentScroll < lastScroll) {
      // 上向き
      target.classList.add(upClass);
      target.classList.remove(downClass);
      // 上向き中クラス
      target.classList.add(scrollingUpClass);
      target.classList.remove(scrollingDownClass);
    }

    // 3. 「スクロール中」解除の判定
    // スクロールが止まってから一定時間（例: 150ms）後にクラスを外す
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(() => {
      target.classList.remove(scrollingUpClass, scrollingDownClass);
    }, scrollingDelayTime);

    lastScroll = currentScroll;
  }, { passive: true });
};




// スライダー(utils)
window.initSwiperSlider = (options = {}) => {
  const {
    wrapperSelector = '.js-slider',
    sliderSelector = '.slider',
    nextSelector = '.swiper-button-next',
    prevSelector = '.swiper-button-prev',
    // Swiper標準のデフォルトオプション
    loop = true,
    effect = 'fade', // slide, fade, cube, coverflow, flip, cards, creative
    speed = 1000,
    autoplayDelay = 4000,
    threshold = 5,
    touchAngle = 30,
    touchRatio = 1.5,
    longSwipesRatio = 0.1,
    // 追加のSwiperオプション（必要に応じて外部から丸ごと上書きできるように）
    extraOptions = {}
  } = options;

  const wrappers = document.querySelectorAll(wrapperSelector);
  if (wrappers.length === 0) return;

  wrappers.forEach((wrapper) => {
    const mainElement = wrapper.querySelector(sliderSelector);
    if (!mainElement) return;

    // ナビゲーションボタンの取得
    const nextEl = wrapper.querySelector(nextSelector);
    const prevEl = wrapper.querySelector(prevSelector);

    // Swiperの初期化設定を組み立て
    const swiperConfig = {
      loop,
      effect,
      speed,
      threshold,
      touchAngle,
      touchRatio,
      longSwipesRatio,
      // オートプレイの設定（falseが明示された場合は無効化できるように考慮）
      autoplay: autoplayDelay ? { delay: autoplayDelay } : false,
      // ナビゲーション要素が存在する場合のみ設定
      navigation: (nextEl || prevEl) ? { nextEl, prevEl } : false,
      // その他のカスタムオプションをマージ
      ...extraOptions
    };

    // スライダーのインスタンス化
    new Swiper(mainElement, swiperConfig);
  });
};


// ギャラリー(メイン+サムネイル連動)(utils)
window.initSwiperGallery = (options = {}) => {
  const {
    wrapperSelector = '.js-productGallery',
    mainSelector = '.js-productMainSlider',
    thumbsSelector = '.js-productThumbs',
    thumbItemSelector = '.js-productThumbs__item',
    activeClass = 'is-active',
    // Swiper標準のデフォルトオプション（メイン側のみ。サムネイルはSwiper化しない）
    loop = true,
    effect = 'fade',
    speed = 600,
    // 追加のSwiperオプション（必要に応じて外部から丸ごと上書きできるように）
    extraOptions = {}
  } = options;

  const wrappers = document.querySelectorAll(wrapperSelector);
  if (wrappers.length === 0) return;

  wrappers.forEach((wrapper) => {
    const mainElement = wrapper.querySelector(mainSelector);
    if (!mainElement) return;

    // メインスライダーのみSwiper化
    const mainSwiper = new Swiper(mainElement, {
      loop,
      effect,
      speed,
      ...extraOptions
    });

    // サムネイルは静的グリッド。クリックでメインスライダーを切り替える
    const thumbsWrapper = wrapper.querySelector(thumbsSelector);
    if (!thumbsWrapper) return;

    const thumbItems = thumbsWrapper.querySelectorAll(thumbItemSelector);
    if (thumbItems.length === 0) return;

    const setActiveThumb = (index) => {
      thumbItems.forEach((item, i) => {
        item.classList.toggle(activeClass, i === index);
      });
    };

    thumbItems.forEach((item, index) => {
      item.addEventListener('click', () => {
        if (typeof mainSwiper.slideToLoop === 'function' && loop) {
          mainSwiper.slideToLoop(index);
        } else {
          mainSwiper.slideTo(index);
        }
      });
    });

    // メインスライダー側の変化にもサムネイルの選択状態を追従させる
    mainSwiper.on('slideChange', () => {
      setActiveThumb(mainSwiper.realIndex);
    });

    setActiveThumb(mainSwiper.realIndex);
  });
};


// 商品レコメンデーション(utils)
window.initProductRecommendations = (options = {}) => {
  const {
    selector = '.js-productRecommendations',
    loadedClass = 'is-loaded'
  } = options;

  const containers = document.querySelectorAll(selector);
  if (containers.length === 0) return;

  containers.forEach((container) => {
    const url = container.dataset.url;
    if (!url) return;

    fetch(url)
      .then((response) => response.text())
      .then((html) => {
        if (html.trim() === '') return; // 該当商品なし
        container.innerHTML = html;
        container.classList.add(loadedClass);
      })
      .catch((error) => {
        console.error('Product recommendations fetch failed:', error);
      });
  });
};

// フォーム 添付ファイル(utils)
window.initFormFileInputs = (options = {}) => {
  const {
    wrapperSelector = '.js-formFile__wrapper', // 変更
    fileInputSelector = '.js-formFile__input', // 変更
    resetSelector = '.js-formFile__reset',     // 変更
    nameSelector = '.js-formFile__name',       // 変更
    changedClass = 'is-selected',
    emptyText = '選択されていません',
  } = options;

  // input基準で要素を全取得
  const fileInputs = document.querySelectorAll(fileInputSelector);
  if (fileInputs.length === 0) return;

  fileInputs.forEach(input => {
    // 各inputに対して、一番近い親ラッパーを探す
    const parent = input.closest(wrapperSelector);
    if (!parent) return; 

    const nameDisplay = parent.querySelector(nameSelector);
    const resetButton = parent.querySelector(resetSelector);

    // 1. ファイル選択時（changeイベント）
    input.addEventListener('change', function () {
      const file = this.files[0];

      if (file) {
        parent.classList.add(changedClass);
        if (nameDisplay) {
          nameDisplay.textContent = file.name;
        }
      } else {
        // 万が一選択が空で確定された場合のケア
        resetFileInput();
      }
    });

    // 2. 取消ボタンクリック時
    if (resetButton) {
      resetButton.addEventListener('click', function () {
        resetFileInput();
      });
    }

    // 共通のクリア処理
    function resetFileInput() {
      parent.classList.remove(changedClass);
      input.value = ''; // 選択したファイルをクリア
      if (nameDisplay) {
        nameDisplay.textContent = emptyText;
      }
    }
  });
};


// プルプル
window.initPulpul = (options = {}) => {
  const {
    targetSelector = '.js-pulpul',
    rangeX = 6,
    rangeY = 6,
    intervalMin = 50,          // 1フレームの最短時間 (ms)
    intervalMax = 100,         // 1フレームの最長時間 (ms)
    shakeDurationMin = 1500,    // 振動し続ける最短時間 (ms)
    shakeDurationMax = 2000,   // 振動し続ける最長時間 (ms)
    pauseMin = 500,
    pauseMax = 2000,
  } = options;

  const elements = document.querySelectorAll(targetSelector);
  const timers = new Map();

  function startShaking(el) {
    const duration = shakeDurationMin
      + Math.random() * (shakeDurationMax - shakeDurationMin);
    const endAt = Date.now() + duration;

    function shakeOne() {
      if (Date.now() >= endAt) {
        pause(el);
        return;
      }
      const x = (Math.random() - 0.5) * 2 * rangeX;
      const y = (Math.random() - 0.5) * 2 * rangeY;
      el.style.transform = `translate(${x}px, ${y}px)`;
      const interval = intervalMin + Math.random() * (intervalMax - intervalMin);
      const id = setTimeout(shakeOne, interval);
      timers.set(el, id);
    }

    shakeOne();
  }

  function pause(el) {
    el.style.transform = '';
    const wait = pauseMin + Math.random() * (pauseMax - pauseMin);
    const id = setTimeout(() => startShaking(el), wait);
    timers.set(el, id);
  }

  elements.forEach(el => startShaking(el));

  return {
    stop() {
      timers.forEach((id, el) => {
        clearTimeout(id);
        el.style.transform = '';
      });
      timers.clear();
    }
  };
};

